/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableCell, TableRow } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { FormikProps } from 'formik/dist/types';
import { FastField } from 'formik';
import { Config, IQueueConfiguration } from '../types';

interface IQueueTableRowProps extends Partial<FormikProps<IQueueConfiguration>> {
  row: Config;
  initialValue: any;
  isError: boolean;
  options?: any[] | undefined;
}

const QueueTableRow: FC<IQueueTableRowProps> = ({ setFieldValue, initialValue, row, isError }) => {
  const [isChanged, setIsChanged] = useState<boolean>(false);

  const handleOnChange = (value: string) => {
    if (value === 'false' || value === 'true' || value === 'null') {
      setFieldValue?.(row?.name, JSON.parse(value));
    } else {
      setFieldValue?.(row?.name, value);
    }
  };

  useEffect(() => {
    setIsChanged(row.value !== initialValue);
  }, [row]);

  return (
    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell component="th" scope="row" sx={isError ? { color: 'red' } : isChanged ? { fontWeight: 700 } : null}>
        {row.title}
      </TableCell>

      <TableCell align="right">
        {row?.component && (
          <FastField
            {...row}
            name={row?.name}
            value={row?.type === 'boolean' && row?.value === null ? String(Boolean(row?.value)) : String(row?.value)}
            component={row?.component}
            style={{ maxHeight: '30px', maxWidth: '137px' }}
            onChange={handleOnChange}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default QueueTableRow;
